import type { DocumentReference, Timestamp } from "firebase/firestore";

export type User = {
  name: string;
  distributor: string;
};

export const isUser = (user: unknown): user is User =>
  user !== null &&
  user !== undefined &&
  typeof user === "object" &&
  "name" in user &&
  "distributor" in user &&
  typeof user.name === "string" &&
  typeof user.distributor === "string";

export type Distributor = {
  name: string;
};

export const isDistributor = (
  distributor: unknown,
): distributor is Distributor =>
  distributor !== null &&
  distributor !== undefined &&
  typeof distributor === "object" &&
  "name" in distributor;

export type Ticket = {
  reference: DocumentReference;
  identifier: string;
  isSold: boolean;
  lottery: string;
  soldDate?: Timestamp;
  soldBy?: string;
};

const requiredTicketKeys: (keyof Ticket)[] = ["identifier", "isSold", "lottery"] as const;

export const isTicket = (ticket: unknown): ticket is Ticket => {
  return (
    ticket !== null &&
    ticket !== undefined &&
    typeof ticket === "object" &&
    requiredTicketKeys.every((key) => key in ticket) &&
    typeof ticket.identifier === "string" &&
    typeof ticket.isSold === "boolean" &&
    typeof ticket.lottery === "string" //&&
    // typeof ticket.soldBy === "string" &&
    // typeof ticket.soldDate === "object" &&
    // "toDate" in ticket.soldDate
  );
};

export interface LoginCredentials {
  email: string;
  password: string;
}
